import { useEffect, useRef, useState } from "react";
import { Table } from "antd";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import StatusTag from "../../../components/StatusTag";
import ActionColumn from "../../../components/ActionColumn";

const DemoGivenList = () => {
  const calledOnce = useRef(false);
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const DEMO_GIVEN_LIST = () => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.demo_given_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.data);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
      set_page_loader(false);
    }
  };

  const BLOCK_TRIAL_REQUEST_API = (company_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("company_id", company_id);
      post(ApiURL.block_trial_request, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success", res?.message);
          DEMO_GIVEN_LIST();
        } else {
          ErrorToast("Error", res?.message);
        }
      });
    } catch (error) {
      console.error("Error changing company status:", error);
    } finally {
    }
  };

  const TRIAL_REQUEST_API = (company_id, days) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("company_id", company_id);
      FORM_DATA.append("days", days);
      post(ApiURL.trial_request, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success", res?.message);
          DEMO_GIVEN_LIST();
        } else {
          ErrorToast("Error", res?.message);
        }
      });
    } catch (error) {
      console.error("Error sending trial request:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (!calledOnce.current) {
      DEMO_GIVEN_LIST();
      calledOnce.current = true;
    }
  }, []);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
    },
    {
      title: "Email",
      dataIndex: "company_email",
      align: "center",
      key: "company_email",
    },

    {
      title: "Country",
      dataIndex: "country",
      align: "center",
      key: "country",
    },

    {
      title: "Demo Status",
      dataIndex: "all_status",
      align: "center",
      key: "all_status",
      render: (all_status) => (
        <StatusTag status={all_status ? all_status : ""} />
      ),
    },
    {
      title: "Trial Status",
      dataIndex: "trial_status",
      align: "center",
      key: "trial_status",
      render: (trial_status) => (
        <StatusTag status={trial_status ? trial_status : ""} />
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => new Date(record?.created_at).toLocaleString(),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => new Date(record?.updated_at).toLocaleString(),
    },
    {
      title: "Action",
      align: "center",
      key: "action",

      render: (text, record) => (
        <ActionColumn
          record={record}
          onSchedule={(rec, days) => {
            console.log("Schedule API call:", rec.id, days);
            TRIAL_REQUEST_API(rec.id, days);
          }}
          onBlock={(rec) => {
            console.log("Block API call:", rec.id);
            BLOCK_TRIAL_REQUEST_API(rec.id);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{ padding: "10px" }}>
          <div
            className="col-3"
            style={{ marginLeft: "5px", alignSelf: "end" }}
          >
            <div className="theme-content-title text-left">
              <h3>Demo Given List</h3>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default DemoGivenList;
